
# for R(otaville) models, collections and code
window.R ?= {}

# for V(iew) releated code
window.V ?= {}

